import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import PhoneField from "@/components/PhoneField.vue";
let TelegramAuth = class TelegramAuth extends Vue {
    sendTelegramCommand;
    getMyCompanyFromStore;
    getTelegramIntegrationState;
    fetchCompany;
    value;
    isCodeWaiting = false;
    isCodeVerifying = false;
    isPasswordVerifying = false;
    phone = '';
    code = '';
    password = '';
    phoneCodeHash = '';
    currentTelegramUser = {};
    error = '';
    get company() {
        return this.getMyCompanyFromStore("mine") || {};
    }
    get currentStage() {
        const telegramIntegrationState = this.getTelegramIntegrationState(this.company.id);
        if (!telegramIntegrationState)
            return 'phone';
        switch (telegramIntegrationState.state) {
            case 'codeSendError':
                this.error = telegramIntegrationState.error;
                if (telegramIntegrationState.error.error_code === 420)
                    this.error = "Too many requests. Try again later";
            case 'codeSent':
                this.isCodeWaiting = false;
                this.phoneCodeHash = telegramIntegrationState.phoneCodeHash;
                return 'code';
            case 'verifyCodeError':
                this.error = telegramIntegrationState.error;
            case '2FARequired':
                this.isCodeVerifying = false;
                return '2FA';
            case 'loggedIn':
                this.currentTelegramUser = telegramIntegrationState.user;
                this.phone = '';
                this.code = '';
                this.password = '';
                this.isCodeVerifying = false;
                this.isPasswordVerifying = false;
                return 'completed';
            case 'getUserError':
                this.disconnect();
            default:
                return 'phone';
        }
    }
    async requestLoginCode() {
        this.error = '';
        this.sendTelegramCommand({
            action: 'auth.sendCode',
            phoneNumber: this.phone,
            companyId: this.company.id
        });
        this.isCodeWaiting = true;
    }
    async verifyCode() {
        this.error = '';
        this.sendTelegramCommand({
            action: 'auth.verifyCode',
            code: this.code,
            phoneNumber: this.phone,
            companyId: this.company.id
        });
        this.isCodeVerifying = true;
    }
    async sendPassword() {
        this.error = '';
        this.sendTelegramCommand({
            action: 'auth.checkPassword',
            password: this.password,
            phoneNumber: this.phone,
            companyId: this.company.id
        });
        this.isPasswordVerifying = true;
    }
    async disconnect() {
        await this.sendTelegramCommand({
            action: 'auth.logOut',
            companyId: this.company.id,
            phoneNumber: this.currentTelegramUser.phone,
        });
    }
    get showError() {
        return this.error ? false : null;
    }
    get errorDescription() {
        switch (this.error) {
            case 'PHONE_CODE_INVALID':
                return this.$t('Invalid code').toString();
            case 'PASSWORD_HASH_INVALID':
                return this.$t('Invalid password').toString();
            case 'PHONE_NUMBER_INVALID':
                return this.$t('Invalid phone number').toString();
        }
        if (this.error.startsWith('FLOOD_WAIT_')) {
            return this.$t('Too many attempts. Try again later').toString();
        }
        return this.error;
    }
    onCompanyChange(company) {
        if (company && company.id) {
            this.sendTelegramCommand({
                action: 'getCurrentUser',
                companyId: company.id,
            });
        }
    }
};
__decorate([
    Prop({ type: Object })
], TelegramAuth.prototype, "value", void 0);
__decorate([
    Watch('company', { deep: true, immediate: true })
], TelegramAuth.prototype, "onCompanyChange", null);
TelegramAuth = __decorate([
    Component({
        components: {
            PhoneField,
        },
        methods: {
            ...mapActions('company', {
                fetchCompany: 'get',
            }),
            ...mapActions('telegram-integration', { sendTelegramCommand: 'create' }),
        },
        computed: {
            ...mapGetters('my-company', {
                getMyCompanyFromStore: 'get'
            }),
            ...mapGetters('telegram-integration', {
                getTelegramIntegrationState: 'get',
            }),
        }
    })
], TelegramAuth);
export default TelegramAuth;
